'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtTaskStatusIcon', [
	function () {

		return {
			restrict: 'A',
			replace: true,
			scope: {
				statusDone: '=pmtTaskStatusIcon',
				statusDisabled: '=disabled'
			},
			link: function (/*scope, element, attrs*/) {},
			templateUrl: 'components/claim/taskStatusIcon/pmtTaskStatusIconView.html'
		};
	}
]);
